/** @format */

import { Action, createReducer, on } from '@ngrx/store';
import { addCompareProduct, setCompareProductDetails, setCompareProductDetailsCallFailed, setCompareProducts, setCompareSkeletonLoader, setIsCompareFeatureHidden } from './compare.actions';

import { CompareState } from '@plp/data-access/interfaces';

export const initialCompareState: CompareState = {
	compareProducts: [],
	hasProductDetailsCallFailed: false,
	isCompareFeatureHidden: true,
	isCompareSkeletonLoaderVisible: true,
	productDetails: null,
};

const productCompareReducer = createReducer(
	initialCompareState,
	on(setCompareProducts, (state, { compareProducts }) => ({
		...state,
		compareProducts
	})),
	on(addCompareProduct, (state, { compareProduct }) => {
		const newCompareList = [...state.compareProducts, compareProduct];
		return {
			...state,
			compareProducts: newCompareList
		};
	}),
	on(setCompareProductDetails, (state, { productDetails }) => ({
		...state,
		productDetails })),
	on(setCompareSkeletonLoader, (state, { isCompareSkeletonLoaderVisible }) => ({
		...state,
		isCompareSkeletonLoaderVisible
	})),
	on(setCompareProductDetailsCallFailed, (state, { hasProductDetailsCallFailed }) => ({
		...state,
		hasProductDetailsCallFailed
	})),
	on(setIsCompareFeatureHidden, (state, { isCompareFeatureHidden }) => ({
		...state,
		isCompareFeatureHidden
	}))
);

export function compareReducer(state: CompareState | undefined, action: Action) {
	return productCompareReducer(state, action);
}
